import { createSelector } from '@ngrx/store';

import { getSearchState, SearchState } from '../reducers';
import * as fromSearchDataReducers from './search.reducers';

export const getSearchPropertySearcherState = createSelector(
  getSearchState,
  (state: SearchState) => state.searchPropertySearcher
);

export const getSearchActionState = createSelector(
  getSearchPropertySearcherState,
  fromSearchDataReducers.getSearchActionState
);
export const getSearchData = createSelector(
  getSearchPropertySearcherState,
  fromSearchDataReducers.getSearchData
);
export const getPagination = createSelector(
  getSearchPropertySearcherState,
  fromSearchDataReducers.getPagination
);
export const getSelectedPropertySearcher = createSelector(
  getSearchPropertySearcherState,
  fromSearchDataReducers.getSelectedPropertySearcher
);
